import { useCallback, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import moment from "moment";
const ContentHistoryModal = (props: any) => {
  const { isOpen, onClose, contentHistory } = props;
  const [historyEdit, setHistoryEdit] = useState<any>([]);

  const getDistinctByProperty = <T, K>(arr: T[], prop: (obj: T) => K): T[] => {
    const seen = new Set<K>();
    return arr.filter((item) => {
      const value = prop(item);
      if (seen.has(value)) {
        return false;
      }
      seen.add(value);
      return true;
    });
  };

  const getHistory = useCallback(() => {
    if (contentHistory) {
      const distinctArr = getDistinctByProperty(contentHistory, (item: any) => item.fields.Content);
      const arr = distinctArr.map((e: any) => {
        const localDate = moment(e.lastModifiedDateTime).subtract(7, "hour");
        const time = localDate.format("DD/MM/YYYY HH:mm");
        return {
          user: e.lastModifiedBy.user.displayName,
          time: time,
          content: e.fields.Content,
          summary: e.fields.ContentSummary,
        };
      });
      setHistoryEdit(arr);
    }
  }, [contentHistory]);

  useEffect(() => {
    getHistory();
  }, [getHistory, isOpen]);

  return (
    <Modal show={isOpen} onHide={onClose} centered size={"lg"} className="add-folder-modal">
      <Modal.Header closeButton>
        <Modal.Title>Lịch sử soạn thảo</Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-3 px-5">
        {historyEdit &&
          historyEdit.map((e: any, index: number) => {
            return (
              <div key={index}>
                <p>
                  {e.user} <span className="text-secondary"> {"(" + e.time + ") :"}</span>{" "}
                </p>
                <p
                  // style={
                  //   index !== 0
                  //     ? { whiteSpace: "normal", paddingLeft: "15px", color: "#333" }
                  //     : { whiteSpace: "normal", paddingLeft: "15px", color: "blue" }
                  // }
                  style={{ whiteSpace: "normal", paddingLeft: "15px", color: "#333" }}
                  className="scroll-mt-20"
                  dangerouslySetInnerHTML={{ __html: e.content }}
                ></p>
                {e.summary && (
                  <p style={{ whiteSpace: "normal", paddingLeft: "15px", color: "blue" }}>{`Tóm tắt: ${e.summary}`}</p>
                )}
              </div>
            );
          })}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="info" onClick={() => onClose()}>
          Đóng
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default ContentHistoryModal;
